export enum UserStatus {
    INACTIVE = 0,
    ACTIVE,
    DISCONNECTED
}
